var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("Core-Title", { attrs: { loading: _vm.loading } }, [
    _c("div", { staticClass: "bill-header" }, [
      _c("h2", [_vm._v(_vm._s(_vm.code))]),
      _c("span", [_vm._v(_vm._s(_vm.type))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }